import { TranslateService } from '@ngx-translate/core';
import { Component, ViewChild } from '@angular/core';
import {ReportApiService} from 'src/app/data-transfer/services/report-api-service';
import {AuthService} from 'src/app/services/auth-service';
import { TemplateApiService } from 'src/app/data-transfer/services/template-api-service';
import { firstValueFrom } from 'rxjs';
import { downloadDocument } from 'src/app/services/document-download';
import { MatMenu } from '@angular/material/menu';
@Component({
  selector: 'app-downloads-menu',
  templateUrl: './downloads-menu.component.html',
  styleUrls: ['./downloads-menu.component.scss']
})
export class DownloadsMenuComponent {

  @ViewChild(MatMenu, { static: true }) menu!: MatMenu;
  documents!: { label: string, path: string }[];
  isAdmin = false;

  constructor(
    private translateService: TranslateService,
    private reportservice: ReportApiService,
    private authService: AuthService,
    private templateService: TemplateApiService
  ) {
    this.setDocuments();
    this.isAdmin = this.authService.isUserAdmin();
  }

  private setDocuments() {
    const documentsFolder = 'https://cockpit.packaging-cockpit.com/downloads/documents/';
    const preZeroManual =
      'https://prezero-international.com/leistungen/sustainable-packaging/sustainable-packaging-optimization-tool/spot-usermanual';
    const preZeroManualEn =
      'https://prezero-international.com/en/services/sustainable-packaging/sustainable-packaging-optimization-tool/spot-usermanual';
    const format = '.pdf';
    const isEnglish = localStorage.getItem('language') === 'en';
    this.documents = [
      {
        path: isEnglish ? `${preZeroManualEn}` : `${preZeroManual}`,
        label: this.translateService.instant('downloads.file.manual')
      },
      {
        path: isEnglish ? `${documentsFolder}FH-Campus-Wien_Circular-Packaging-Design-Guideline_V04_EN${format}` :
          `${documentsFolder}FH-Campus-Wien_Circular-Packaging-Design-Guideline_V04_DE${format}`,
        label: this.translateService.instant('downloads.file.guidelines')
      },
      {
        path: isEnglish ? `${documentsFolder}Recyclability-Assessment-CA${format}` :
          `${documentsFolder}Bewertung_RF${format}`,
        label: this.translateService.instant('downloads.file.methods')
      }
    ];
  }

  clickExternalHtml() {
    const link = document.createElement('a');
    link.href = 'api-documentation/index.html';
    link.target = '_blank';
    link.click();
  }


  async downloadUsageReport() {
    const observable = this.reportservice.generateUsageReport();
    const reportPdf = await firstValueFrom(observable);
    const pdfUrl = window.URL.createObjectURL(reportPdf);
    window.open(pdfUrl, '_blank');
  }

  async downloadPUImportTemplate() {
    const subscription = this.templateService.getPUImporterTemplate()
      .subscribe(fileToSave => { downloadDocument(fileToSave); subscription.unsubscribe()});
  }
}
